<ng2-smart-table [source]="hubSource" [settings]="settings" (edit)="editHub($event)">
</ng2-smart-table>
